import { redirect } from 'next/navigation';
import { useActionState } from 'react';
import submitFormSubmission from '../../api/actions/submit-form-submission';
import { fireAdConversions } from '../ad-conversions/fire-ad-conversions';
import type { Form } from '../../payload-types';

type SubmitFormSubmissionResult = Awaited<ReturnType<typeof submitFormSubmission>>;

export function createFormAction(form?: Form, redirectOverride?: string) {
  return async (
    _prevState: SubmitFormSubmissionResult | undefined,
    formData: FormData,
  ): Promise<SubmitFormSubmissionResult> => {
    const result = await submitFormSubmission(formData);

    if (result.status === 'success' && form) {
      // One id per submission, shared by every platform that de-duplicates on it.
      fireAdConversions(form, `form-submission.${result.eventId}`);
    }

    if (result.status === 'success') {
      const redirectTo = redirectOverride || result.redirectTo;
      if (redirectTo) {
        redirect(redirectTo);
      }
    }

    return result;
  };
}

const useSubmitFormSubmission = ({ form, redirectOverride }: { form?: Form; redirectOverride?: string } = {}) => {
  const [result, formAction, isPending] = useActionState(createFormAction(form, redirectOverride), undefined);

  return [result, formAction, isPending] as const;
};

export default useSubmitFormSubmission;
